"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detail = detail;
exports.download = download;
exports.downloadAll = downloadAll;
exports.endpoints = void 0;
exports.importAttachment = importAttachment;
exports.upload = upload;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _set = _interopRequireDefault(require("lodash/set"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _utils2 = require("../utils");
var _file = require("../utils/file");
var endpoints = exports.endpoints = {
  upload: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/upload");
    }
  },
  detail: {
    method: 'GET',
    url: function url(messageId, attachmentId) {
      return "".concat(_utils2.WM_API_HOST, "/").concat(_utils2.API_V1, "/attachment/dl/").concat(messageId, "/").concat(encodeURIComponent(attachmentId));
    }
  },
  download: {
    method: 'GET',
    url: function url(messageId, attachmentId) {
      return "".concat(_utils2.WM_API_HOST, "/").concat(_utils2.API_V1, "/attachment/dl/").concat(messageId, "/").concat(encodeURIComponent(attachmentId));
    }
  },
  downloadAll: {
    method: 'GET',
    url: function url(messageId) {
      return "/".concat(_utils2.API_V1, "/attachment/dla/").concat(messageId);
    }
  },
  importAttachment: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/compose/import_attachment");
    }
  }
};
/**
 * Handler to upload file as attachment
 * Return a promise response with the attacthment ID
 *
 * @public
 * @param {File} file - File content with base64 format
 * @param {Auth} auth - User authentication info
 * @returns {Promise<UploadResponse>}
 */
function upload(_ref, progressEvents) {
  var file = _ref.file,
    auth = _ref.auth;
  var xhr = new XMLHttpRequest();
  var headers = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals).headers;
  var form = new FormData();
  form.append('attachment', file);
  var _endpoints$upload = endpoints.upload,
    method = _endpoints$upload.method,
    url = _endpoints$upload.url;
  if (progressEvents) {
    for (var key in progressEvents) {
      (0, _set["default"])(xhr, key, progressEvents[key]);
    }
  }
  xhr.open(method, url());
  for (var header in headers) {
    xhr.setRequestHeader(header, headers[header]);
  }
  var promise = new Promise(function (resolve, reject) {
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          var result = JSON.parse(xhr.responseText);
          if (xhr.status === 200 || xhr.status === 403) {
            resolve(result);
          } else {
            reject(new _requests.RequestError(result.message, result.status, result.status));
          }
        } catch (e) {
          reject(new _requests.RequestError(xhr.statusText, xhr.status, xhr.status));
        }
      }
    };
    xhr.onerror = function (error) {
      return reject(error);
    };
  });
  promise.xhr = xhr;
  xhr.send(form);
  return promise;
}
/**
 * Handler to read attachment content
 * Return base64 data of the content
 *
 * @public
 * @param {string} messageId - Attachment messageId
 * @param {string} attachmentId - Unique ID for the attachment
 * @param {string} size - Unique ID for the attachment
 * @param {Auth} {auth} - User authentication info
 * @returns {Promise<any>}
 */
function detail(_x, _x2, _x3, _x4) {
  return _detail.apply(this, arguments);
}
/**
 * Handler to download attachment content
 * Return blob data
 *
 * @public
 * @param {string} messageId - Unique ID for the message
 * @param {string} attachmentId - Unique ID for the attachment
 * @param {Auth} {auth} - User authentication info
 * @returns {Promise<any>}
 */
function _detail() {
  _detail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(messageId, attachmentId, auth, _ref2) {
    var size, url, blob;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          size = _ref2.size;
          url = endpoints.detail.url;
          _context.next = 4;
          return (0, _file.readFile)("".concat(url(messageId, attachmentId)).concat(size ? "?imgsize=".concat(size) : ''), {
            auth: auth
          });
        case 4:
          blob = _context.sent;
          return _context.abrupt("return", URL.createObjectURL(blob));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _detail.apply(this, arguments);
}
function download(_x5, _x6) {
  return _download.apply(this, arguments);
}
/**
 * Handler to download all attachment content
 * Return blob data
 *
 * @public
 * @param {string} messageId - Unique ID for the message
 * @param {Auth} {auth} - User authentication info
 * @returns {Promise<any>}
 */
function _download() {
  _download = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3, _ref4) {
    var attachmentId, messageId, action, pvformat, auth, optionals, _endpoints$download, method, url;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          attachmentId = _ref3.attachmentId, messageId = _ref3.messageId, action = _ref3.action, pvformat = _ref3.pvformat;
          auth = _ref4.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            action: action,
            pvformat: pvformat
          }))(_utils.defaultOptionals);
          _endpoints$download = endpoints.download, method = _endpoints$download.method, url = _endpoints$download.url;
          _context2.next = 6;
          return (0, _requests.request)(url(messageId, attachmentId), method, optionals);
        case 6:
          return _context2.abrupt("return", _context2.sent);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _download.apply(this, arguments);
}
function downloadAll(_x7, _x8) {
  return _downloadAll.apply(this, arguments);
}
function _downloadAll() {
  _downloadAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(messageId, _ref5) {
    var auth, optionals, _endpoints$downloadAl, method, url;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          auth = _ref5.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$downloadAl = endpoints.downloadAll, method = _endpoints$downloadAl.method, url = _endpoints$downloadAl.url;
          _context3.next = 5;
          return (0, _requests.request)(url(messageId), method, optionals);
        case 5:
          return _context3.abrupt("return", _context3.sent);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _downloadAll.apply(this, arguments);
}
function importAttachment(_x9, _x10) {
  return _importAttachment.apply(this, arguments);
}
function _importAttachment() {
  _importAttachment = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(options, auth) {
    var optionals, _endpoints$importAtta, method, url;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(options))(_utils.defaultOptionals);
          _endpoints$importAtta = endpoints.importAttachment, method = _endpoints$importAtta.method, url = _endpoints$importAtta.url;
          _context4.next = 4;
          return (0, _requests.request)(url(), method, optionals);
        case 4:
          return _context4.abrupt("return", _context4.sent);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _importAttachment.apply(this, arguments);
}
//# sourceMappingURL=attachments.js.map